export default {
  gaAction: 'Theme Park',
  smallHeadingText: "A VACATION YOU'LL REMEMBER FOREVER",
  headingText: 'Walt Disney World Vacations',
  contentText:
    'Book your Walt Disney World tickets here! Plus, complete your vacation and book your hotel.',
  image:
    'https://s1.pclncdn.com/pcln/promotions/disney-universal-2020/StarWarsGalaxyEdge.jpg',
  imageWebP:
    'https://s1.pclncdn.com/pcln/promotions/disney-universal-2020/StarWarsGalaxyEdge.webp',
  imageSize: '524px 322px',
  buttons: [
    {
      gaLabel: 'Walt Disney World',
      buttonText: 'More Info',
      linkUrl: '/partner/hotels/walt-disney-world-v1.html'
    }
  ]
}
